import { render, staticRenderFns } from "./apiCode.vue?vue&type=template&id=5aacc615"
import script from "./apiCode.vue?vue&type=script&lang=js"
export * from "./apiCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports